import numeral from 'numeral'

// Similar to formatAmount(), but does not insert spaces or use dash
export const formatAmountForInput = (amount: number) => numeral(amount).format('0.[00]')
